/* eslint-disable no-alert */
// #region import
import React from 'react';
// #endregion import

export const FileSelect = (props: any) => {
  const { file, setFile } = props;
  const { fileName, setFileName } = props;

  const onChangeFile = (target: EventTarget & HTMLInputElement) => {
    const { files } = target;
    if (files && files[0]) {
      const allowExtensions = '.(jpeg|jpg|png|webp|pdf)$'; // 許可する拡張子
      if (!files[0].name.match(allowExtensions)) {
        // 許可する拡張子以外の場合
        alert(
          '拡張子が jpeg, jpg, png, webp, pdf 以外のファイルはアップロードできません。'
        );
        return;
      }
      if (files[0].size > 10000000) {
        // ファイルサイズが10MB以上の場合
        alert('サイズが 10MB 以上のファイルはアップロードできません。');
        return;
      }
      setFile(files[0]);
      setFileName(target.value);
    } else {
      setFileName('');
    }
  };

  return (
    <label className="file">
      <input
        name="file"
        type="file"
        accept="image/.jpeg,.jpg,.png,.webp,.pdf"
        ref={file}
        value={fileName}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChangeFile(e.target)
        }
      />
    </label>
  );
};
export default FileSelect;
